import React from "react";

import {
  DEFAULT_PRIORITY_SCORING_WEIGHTS,
  type PriorityScoringWeights,
} from "../../MyPortfolioAccounts/relationshipPriorityScoring";

export { DEFAULT_PRIORITY_SCORING_WEIGHTS };
export type { PriorityScoringWeights };

export function normalizePriorityScoringWeights(
  raw: unknown
): PriorityScoringWeights {
  const base = { ...DEFAULT_PRIORITY_SCORING_WEIGHTS };
  if (!raw || typeof raw !== "object") return base;
  const record = raw as Record<string, unknown>;
  const result = { ...base };
  (Object.keys(base) as (keyof PriorityScoringWeights)[]).forEach(key => {
    const n = Number(record[key]);
    if (Number.isFinite(n) && n >= 0) result[key] = n;
  });
  return result;
}

const FIELDS: {
  key: keyof PriorityScoringWeights;
  label: string;
  desc: string;
}[] = [
  {
    key: "riskWeight",
    label: "Account risk (cluster / renewal)",
    desc: "Higher = Triage/Defend accounts and near-term renewals pull rank harder.",
  },
  {
    key: "relationshipGapWeight",
    label: "RL gap from goal",
    desc: "Higher = a bigger gap between current and goal RL matters more.",
  },
  {
    key: "seniorityWeight",
    label: "Contact seniority",
    desc: "Higher = C-suite/EVP/SVP contacts rank higher relative to others.",
  },
  {
    key: "signalConfidenceWeight",
    label: "Signal confidence (recency)",
    desc: "Higher = staler assessments push a pair further down the list.",
  },
];

export interface PriorityScoringWeightsFormProps {
  value: PriorityScoringWeights;
  onChange: (patch: Partial<PriorityScoringWeights>) => void;
}

const PriorityScoringWeightsForm: React.FC<PriorityScoringWeightsFormProps> = ({
  value,
  onChange,
}) => {
  return (
    <div className="space-y-4">
      {FIELDS.map(field => (
        <div key={field.key}>
          <div className="mb-1 flex items-center justify-between gap-3">
            <span className="text-sm font-semibold text-gray-800">
              {field.label}
            </span>
            <div className="flex items-center gap-2">
              <input
                type="range"
                min={0}
                max={2}
                step={0.05}
                value={value[field.key]}
                onChange={e =>
                  onChange({
                    [field.key]: Number(e.target.value),
                  } as Partial<PriorityScoringWeights>)
                }
                className="w-40"
              />
              <span className="w-10 text-right text-sm font-bold tabular-nums text-gray-700">
                {value[field.key].toFixed(2)}×
              </span>
            </div>
          </div>
          <p className="text-xs text-gray-500">{field.desc}</p>
        </div>
      ))}
    </div>
  );
};

export default PriorityScoringWeightsForm;
